import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { initLocalization, setLocale } from '../actions';

@Injectable()
export class LocalizationDispatcher {
  constructor(private _store: Store<any>) {}

  initLocalization() {
    this._store.dispatch(initLocalization());
  }

  setLocale(locale: string) {
    this._store.dispatch(setLocale(locale));
  }
}
